import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Office: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m658.96 640.05-30-.1.86-264.82c.04-12.04-4.63-23.38-13.13-31.91s-19.82-13.23-31.87-13.23h-134.81v-30h134.81c20.08 0 38.94 7.83 53.12 22.05 14.17 14.22 21.95 33.11 21.88 53.18l-.86 264.82z' />
    <path d='m720 660h-660v-30h630c16.57 0 30 13.43 30 30z' />
    <path d='m240 330v90h-30v-60c0-16.57 13.43-30 30-30z' />
    <path d='m240 480v90h-30v-60c0-16.57 13.43-30 30-30z' />
    <path d='m330 330v90h-30v-60c0-16.57 13.43-30 30-30z' />
    <path d='m330 480v90h-30v-60c0-16.57 13.43-30 30-30z' />
    <path d='m420 640h-30v-444.94c0-15.09-7.14-28.62-19.59-37.14-12.14-8.3-26.9-10.18-40.66-5.2l-179.75 105.85v376.43h-30v-393.57l196.69-115.83 1.13-.44c23.09-8.98 49.08-5.99 69.53 8s32.65 37.13 32.65 61.9z' />
  </IconBase>
));

Office.displayName = 'Office';

export default Office;
